import { render, staticRenderFns } from "./satchel_plans.vue?vue&type=template&id=49fcf478&"
import script from "./satchel_plans.vue?vue&type=script&lang=js&"
export * from "./satchel_plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports